import type { ToggleSwitchDesignTokens } from '@primeuix/themes/types/toggleswitch';

export const ToggleSwitchDT = {
	toggleswitch: <ToggleSwitchDesignTokens>{
		colorScheme: {
			light: {
				root: {
					checkedBackground: '#1EA97C',
					checkedHoverBackground: '#188d6a',
				},
			},
			dark: {
				root: {
					checkedBackground: '#1EA97C',
					checkedHoverBackground: '#188d6a',
				},
			},
		},
	},
};
